import React from 'react';
import { Content } from '../../types/content';
import { useTheme } from '../../contexts/ThemeContext';

interface TextContentProps {
  content: Content;
}

export default function TextContent({ content }: TextContentProps) {
  const { theme } = useTheme();

  switch (content.type) {
    case 'post':
      return (
        <p className={`text-sm leading-relaxed ${
          theme === 'dark' ? 'text-gray-100' : 'text-gray-900'
        }`}>
          {content.content}
        </p>
      );
    
    case 'article':
      return (
        <>
          <h2 className={`text-base font-semibold mb-1 ${
            theme === 'dark' ? 'text-gray-100' : 'text-gray-900'
          }`}>
            {content.title}
          </h2>
          <p className={`text-xs line-clamp-2 ${
            theme === 'dark' ? 'text-gray-300' : 'text-gray-600'
          }`}>
            {content.excerpt}
          </p>
        </>
      );
    
    case 'video':
      return (
        <>
          <h2 className={`text-base font-semibold mb-1 ${
            theme === 'dark' ? 'text-gray-100' : 'text-gray-900'
          }`}>
            {content.title}
          </h2>
          <p className={`text-xs line-clamp-2 ${
            theme === 'dark' ? 'text-gray-300' : 'text-gray-600'
          }`}>
            {content.description}
          </p>
        </>
      );
  }
}